import { useEffect, useState } from "react";
import { ExternalLink, MapPin } from "lucide-react";
import mappaStatica from "@/assets/mappa-bottega-osm.webp";
import { EVENTO_CONSENSO, leggiConsenso, salvaConsenso, type Scelte } from "@/lib/consent";

const EMBED = "https://www.google.com/maps?q=Via+J.+F.+Kennedy+1,+Campobasso&output=embed";
const LINK = "https://www.google.com/maps/search/?api=1&query=Via+J.+F.+Kennedy+1,+86100+Campobasso";

// Mappa della pagina Contatti. Prima del consenso c'è un'immagine della zona da OpenStreetMap
// salvata nel sito (nessuna richiesta a terzi); con il consenso «Mappa» si carica Google Maps sopra.
export function MappaGoogle() {
  const [consenso, setConsenso] = useState(false);

  useEffect(() => {
    setConsenso(leggiConsenso()?.mappe === true);
    const aggiorna = (e: Event) => setConsenso((e as CustomEvent<Scelte>).detail?.mappe === true);
    window.addEventListener(EVENTO_CONSENSO, aggiorna);
    return () => window.removeEventListener(EVENTO_CONSENSO, aggiorna);
  }, []);

  const attiva = () => {
    salvaConsenso({ statistiche: leggiConsenso()?.statistiche === true, mappe: true });
  };

  const scheda = (
    <>
      <p className="leading-snug">
        <strong className="font-medium">Via J. F. Kennedy 1, Campobasso</strong>
        <span className="block text-xs text-brand-warm-gray mt-1">
          La mappa interattiva è di Google Maps e usa i suoi cookie: si carica solo se la attivi.
        </span>
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={attiva}
          className="inline-flex items-center gap-2 bg-brand-red hover:bg-brand-red-hover text-white px-3 py-2 rounded-md text-xs uppercase tracking-[0.14em]"
        >
          Mostra Google Maps
        </button>
        <a
          href={LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 border border-brand-charcoal/25 hover:border-brand-red hover:text-brand-red px-3 py-2 rounded-md text-xs uppercase tracking-[0.14em]"
        >
          Indicazioni <ExternalLink size={12} aria-hidden />
        </a>
      </div>
    </>
  );

  return (
    <div>
      <div className="relative rounded-md overflow-hidden shadow-[var(--shadow-soft)] aspect-[16/9] md:aspect-[21/8] bg-brand-cream-dark">
        <img
          src={mappaStatica}
          alt="Mappa della zona di Via J. F. Kennedy 1 a Campobasso"
          width={1600}
          height={610}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {consenso ? (
          <iframe
            title="Mappa La Bottega delle Carni da Marco"
            src={EMBED}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="absolute inset-0 w-full h-full border-0"
          />
        ) : (
          <>
            <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-full text-brand-red drop-shadow-[0_2px_4px_rgba(0,0,0,0.35)]" aria-hidden>
              <MapPin size={40} fill="currentColor" stroke="white" strokeWidth={1.5} />
            </span>
            <div className="hidden sm:block absolute right-3 bottom-3 max-w-sm bg-white/95 rounded-md p-4 shadow-lg text-sm text-brand-charcoal">
              {scheda}
            </div>
            <span className="absolute top-1.5 right-2 text-[10px] text-brand-charcoal/80 bg-white/80 px-1.5 rounded">
              © OpenStreetMap contributors
            </span>
          </>
        )}
      </div>
      {!consenso && (
        <div className="sm:hidden mt-3 bg-white rounded-md p-4 shadow-[var(--shadow-soft)] text-sm text-brand-charcoal">
          {scheda}
        </div>
      )}
    </div>
  );
}
